let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iesUL")).then(() => parcelRequire('7dMNQ'));